import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Row from '../utils/Row'
import Col from '../utils/Col'
import Input from '../utils/Input'
import Field from '../utils/Field'
import CompanySelect from '../branch/CompanySelect'

class Filters extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    filters: PropTypes.object.isRequired,
    handleInputChange: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
  }

  render() {
    const { translate, handleSubmit, filters, handleInputChange, auth } =
      this.props

    return (
      <form
        onSubmit={handleSubmit}
        className='margin-top-double margin-bottom-double'
      >
        <Row>
          <Col sm={2} xs={12} className='margin-top-negative'>
            <Field
              input={{
                value: filters.idBranch,
              }}
              validate
            >
              <CompanySelect
                name='idBranch'
                user={auth.user}
                translate={translate}
                value={filters.idBranch}
                onChange={handleInputChange}
              />
            </Field>
          </Col>

          <Col sm={4} xs={12}>
            <Field
              input={{
                value: filters.dsKey,
              }}
              validate
            >
              <Input
                value={filters.dsKey}
                type='text'
                name='dsKey'
                id='dsKey'
                onChange={handleInputChange}
                label={translate('parameters.dsKey')}
              />
            </Field>
          </Col>

          <Col sm={4} xs={12}>
            <Field
              input={{
                value: filters.dsValue,
              }}
              validate
            >
              <Input
                value={filters.dsValue}
                type='text'
                name='dsValue'
                id='dsValue'
                onChange={handleInputChange}
                label={translate('parameters.dsValue')}
              />
            </Field>
          </Col>

          <Col sm={2} xs={12} className='margin-top'>
            <button className='button button-primary button-full' type='submit'>
              {translate('filter_button_label')}
            </button>
          </Col>
        </Row>
      </form>
    )
  }
}

export default Filters
